module.exports = __webpack_public_path__ + "img/p16.eb2d5c1b.png";